import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchSurveyConfig = async () => {
  const { data } = await api.get("/survey/config");
  return data;
};

export const scoreSurvey = async (answers) => {
  const { data } = await api.post("/survey/score", { answers });
  return data;
};

export const submitSurvey = async (payload) => {
  const { data } = await api.post("/survey/submit", payload);
  return data;
};
